var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: "#1.0",
    d: "M7.124 16c1.528 0 3.1-.475 4.404-1.266.112-.067.157-.18.157-.293 0-.226-.224-.385-.427-.385-.045 0-.112 0-.18.046-1.145.678-2.426 1.084-3.865 1.084-3.685 0-6.382-2.734-6.382-6.327 0-4.226 3.708-8.023 8-8.023 3.798 0 6.27 2.554 6.27 6.17 0 2.78-1.37 3.819-2.247 3.819-.517 0-.921-.34-.921-1.062 0-.136.045-.384.067-.52l.966-4.655c.023-.068.023-.159.023-.226 0-.543-.427-.995-1.056-.995-.495 0-.944.34-1.034.814l-.112.587c-.45-.904-1.439-1.604-2.832-1.604-2.63 0-5.168 2.508-5.168 5.582 0 2.192 1.325 3.751 3.483 3.751 1.28 0 2.561-.768 3.37-1.808.113.972.81 1.808 2.135 1.808 1.91 0 4.225-1.785 4.225-5.491C16 3.186 13.191 0 8.921 0 4.247 0 0 4.068 0 8.904 0 12.904 3.034 16 7.124 16zm-.264-5C5.702 11 5 10.073 5 8.753 5 6.853 6.343 5 8.161 5 9.194 5 9.773 5.788 10 6.367l-.537 2.896C8.946 10.073 8.079 11 6.86 11z",
    transform: "translate(-520 -766) translate(40 766) translate(480) translate(4 4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMention);
export default __webpack_public_path__ + "static/media/mention.e4e7f3ab.svg";
export { ForwardRef as ReactComponent };